import React, { useState, useEffect } from 'react';

export default function AdminSetupForm() {
  const [available, setAvailable] = useState(false);
  const [form, setForm] = useState({
    UserName: 'admin',
    Email: '',
    Password: '',
    RotatingAddresses: Array(8).fill(''),
    MaintenanceBTC: ''
  });
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch('/api/admin-exists')
      .then(res => res.json())
      .then(data => setAvailable(!data.exists));
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAddressChange = (idx, value) => {
    const arr = [...form.RotatingAddresses];
    arr[idx] = value;
    setForm({ ...form, RotatingAddresses: arr });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    const res = await fetch('/api/admin-setup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form)
    });
    if (res.ok) setMessage('Admin setup complete!');
    else {
      const err = await res.json();
      setMessage(err.error || 'Failed');
    }
  };

  if (!available) return <div>Admin setup has already been completed.</div>;

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label>UserName</label>
        <input name="UserName" value={form.UserName} disabled className="input" />
      </div>
      <div>
        <label>Email</label>
        <input name="Email" value={form.Email} onChange={handleChange} className="input" required />
      </div>
      <div>
        <label>Password</label>
        <input name="Password" type="password" value={form.Password} onChange={handleChange} className="input" required />
      </div>
      <div>
        <label>Rotating Bitcoin Addresses (8 required)</label>
        {form.RotatingAddresses.map((addr, idx) => (
          <input
            key={idx}
            value={addr}
            onChange={e => handleAddressChange(idx, e.target.value)}
            className="input"
            placeholder={`Address ${idx + 1}`}
            required
          />
        ))}
      </div>
      <div>
        <label>Maintenance Bitcoin Address</label>
        <input name="MaintenanceBTC" value={form.MaintenanceBTC} onChange={handleChange} className="input" required />
      </div>
      <button type="submit" className="btn btn-primary">Create Admin</button>
      {message && <div>{message}</div>}
    </form>
  );
}
